import React from "react";
import { usePosts } from "../../Hooks/usePosts";
import useToggle from "../../Hooks/useToggle";
import Drawer from "../Mobile/Drawer";
import Footer from "../Partials/Footers/HomeOne/Footer";
import BackToTop from "../Helpers/BackToTop";
import LatestNews from "./LatestNews";
import SportsSection from "./SportsSection";
import EntertainmentSection from "./EntertainmentSection";
import CultureLifestyleHealth from "./CultureLifestyleHealth";
import Search from "../Search";

const ModernHome = () => {
  const { data: posts, isLoading } = usePosts();
  const [drawer, setDrawer] = useToggle(false);
  const [showSearch, setShowSearch] = useToggle(false);
  console.log(posts, "dataa");

  return (
    <>
      <Search
        className={`${showSearch ? "open" : ""}`}
        searchAction={setShowSearch.toggle}
      />
      <Drawer drawer={drawer} action={setDrawer.toggle} />

      {!isLoading && posts && posts.length > 0 ? (
        <main className="modern-layout">
          {/* Hero Slider Section */}
          {/* <HeroSlider posts={posts?.slice(0, 4) || []} /> */}

          {/* Latest News Section */}
          <LatestNews posts={posts?.slice(0, 4) || []} loading={isLoading} />

          {/* Sports Section */}
          <SportsSection
            posts={
              posts
                ?.filter((post) =>
                  post.categories?.some((category) =>
                    category.toLowerCase().includes("sport")
                  )
                )
                ?.slice(0, 5) || []
            }
            loading={isLoading}
          />

          {/* Entertainment Section */}
          {/* <EntertainmentSection
            posts={[
              ...posts
                .filter((p) => p.categories?.includes("Entertainment"))
                .slice(0, 4),
              ...posts
                .filter((p) => p.categories?.includes("entertainment"))
                .slice(0, 4),
            ]}
            loading={isLoading}
          /> */}

          {/* Culture, Lifestyle & Health */}
          <CultureLifestyleHealth
            culturePosts={
              posts
                ?.filter((p) =>
                  p.categories?.some(
                    (cat) =>
                      cat.toLowerCase().includes("culture") ||
                      cat.toLowerCase().includes("kulturë") ||
                      cat.toLowerCase().includes("kulture")
                  )
                )
                ?.slice(0, 3) || []
            }
            lifestylePosts={
              posts
                ?.filter((p) =>
                  p.categories?.some((cat) =>
                    cat.toLowerCase().includes("lifestyle")
                  )
                )
                ?.slice(0, 3) || []
            }
            healthPosts={
              posts
                ?.filter((p) =>
                  p.categories?.some(
                    (cat) =>
                      cat.toLowerCase().includes("health") ||
                      cat.toLowerCase().includes("shëndetësi")
                  )
                )
                ?.slice(0, 3) || []
            }
            loading={isLoading}
          />
        </main>
      ) : isLoading ? (
        <div className="loading-container">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="container text-center py-5">
          <h3>Nuk ka lajme të disponueshme në këtë moment.</h3>
        </div>
      )}

      <Footer />
      <BackToTop />
    </>
  );
};

export default ModernHome;
